module.exports = __webpack_public_path__ + "static/background-pattern-b89622101965b14ff1a158d4e86f9e15.png";